import { selectRecordModal } from '@app/components/RecordModal/model/selectors';
import { useAppSelector } from '@app/store';

export const useVisitsHistoryTab = () => {
  const { clientId, record } = useAppSelector(selectRecordModal);

  return { clientId: record?.ClientId ?? clientId };
};
